import React, { useEffect } from 'react'
import '../../Css/Savani.css'
import Service from '../../Image/Service/Service.png'
import aboutMobile from '../../Image/Mobile/About-Mobile.svg'
import aboutSeo from '../../Image/Seo/About-seo.svg'
import aboutDesign from '../../Image/Design/About-Design.svg'
import aboutResDesign from '../../Image/ResponsiveDesign/AboutRes-Design.svg'
import aboutFullStack from '../../Image/FullStack/About-FullStack.svg'
import aboutDigitalMarketing from '../../Image/DigitalMarketing/About-Marketing.png'
import aboutReactNative from '../../Image/ReactNative/About-ReactNative.svg'
import Wave from 'react-wavify'
import { useParams } from 'react-router-dom'
import 'aos/dist/aos.css';
import Aos from 'aos'

const AboutService = () => {
    const { category } = useParams();

 

    const aboutService = {
        web: {
            paragraph: [
                "Your custom business ideas demand a highly responsive web experience. Kalathiya Infotech’s bold approach assists clients analyze disruptive B2B or B2C challenges to create intuitive UI/UX, fully functional, and robust web technology solutions.","Whether it's building intuitive user interfaces, implementing complex backend functionality, or ensuring seamless performance across devices, we're dedicated to delivering high-quality web applications that drive success and exceed expectations. Partner with us to transform your vision into reality and elevate your online presence."
            ],
            img: {
              src: Service,
              alt: "Service",
            }
        },
        mobile: {
            paragraph: [
                "We are leading mobile application development services with more than a decade of experience and expertise. Get remarkable mobile applications with an innovative approach for small to large scale enterprises.",
                'At <span class="highlight-company">Kalathiya Infotech</span>, we specialize in crafting high-performance, user-friendly mobile applications that help businesses stay ahead in the digital era. Whether you\'re a startup or an established enterprise, our custom mobile app solutions are designed to meet your unique needs and drive real results.'
            ],
            img: {
              src: aboutMobile,
              alt: "Mobile",
            }
        },
        seo: {
            paragraph: [
                "Search Engine Optimization (SEO) is a digital marketing strategy aimed at improving a website’s visibility in search engine results pages (SERPs). Its aim of SEO is to Increase Organic (non-paid) Traffic to a website by optimizing various elements such as keywords, meta tags, content quality, & backlinks, and adhering to search engine algorithms’ guidelines.",
                'At <span class="highlight-company">Kalathiya Infotech</span>, we help businesses rank higher on Google and other search engines through smart, ethical, and results-driven SEO strategies. Our goal is simple — to bring more traffic, better leads, and increased sales for your business.'
            ],
            img: {
                src: aboutSeo,
                alt: "Seo"
            }
        },
        design: {
            paragraph: [
                '<span class="highlight-company">Design is POWER</span> it inspires and convinces users to stay engaged. We bring power to our design with a human-centered design process by not just keeping the users in mind but even by involving the users in the process. As a result, we build A design that delights users.',"Our design services encompass a wide spectrum, from captivating visual identities to intuitive user interfaces. With a keen eye for detail and a passion for creativity, our team of designers works closely with clients to understand their unique brand identity and objectives. Whether it's crafting stunning logos, designing engaging websites, or conceptualizing memorable marketing materials, we combine strategic thinking with innovative design to deliver impactful solutions that elevate your brand and leave a lasting impression."
            ],
            img: {
                src: aboutDesign,
                alt: "Ui Ux Design"
            }
        },
        responsiveDesign: {
            paragraph: [
                "In today's digital landscape, it's essential to prioritize the needs of individuals who have been immersed in the online world since childhood, seamlessly transitioning between web and mobile experiences. Recognizing this, we emphasize responsive web design to cater to this diverse audience. Our team of design specialists is dedicated to tailoring standards to suit any platform or device, ensuring your website or mobile app resonates with a wide-ranging audience.",
                'At <span class="highlight-company">Kalathiya Infotech</span>, we build fast, secure, and fully responsive websites that deliver seamless user experiences across all screen sizes. Whether it’s a smartphone, tablet, laptop, or desktop — your website will look stunning and function flawlessly.'
            ],
            img: {
                src: aboutResDesign,
                alt: "Responsive Web Design"
            }
        },
        fullStack: {
            paragraph: [
                "A Full Stack Developer possesses the skills and expertise to handle various layers of the development process, from crafting user interfaces to managing databases and server-side logic.The term stack refers to the combination of technologies and tools used to build a web application.","Our team of skilled developers excels in utilizing a wide array of programming languages, frameworks, and technologies to build comprehensive web applications from scratch. From crafting sleek and intuitive user interfaces to implementing robust server-side logic and database management systems, we have the expertise to handle every aspect of the development process seamlessly. With a focus on efficiency, scalability, and performance, we ensure that our full-stack solutions not only meet but exceed the expectations of our clients."
            ],
            img: {
                src: aboutFullStack,
                alt: "Full Stack Development"
            }
        },
        digitalMarketing: {
            paragraph: [
                "Digital marketing encompasses a diverse array of strategies aimed at most effective platforms to promote business and engaging with audiences in the digital realm. it contain Social Media, Search Engines, Email, Content Marketing, Camping, and more. digital marketing services Main objectives are to increase brand visibility, drive website traffic, boost conversion rates, and promote businesses.",
                'At <span class="highlight-company">Kalathiya Infotech</span>, we help brands grow their online presence, drive targeted traffic, and convert visitors into loyal customers. Our tailored digital marketing strategies are data-driven, ROI-focused, and designed to deliver measurable results.'
            ],
            img: {
                src: aboutDigitalMarketing,
                alt: "Digital Marketing"
            }
        },
        reactNative: {
            paragraph: [
                '<span class="highlight-company">Kalathiya Infotech</span> specializes in crafting cutting-edge web solutions tailored to meet the unique demands of businesses. Our innovative approach enables us to effectively address complex challenges in both B2B and B2C environments. We excel in developing user-friendly interfaces, seamless user experiences, and resilient web technologies that empower our clients to thrive in today\'s dynamic digital landscape.',
                'We streamline the development process without compromising on performance or user experience. Our team of experienced developers leverages the flexibility and efficiency of React Native to build immersive and feature-rich mobile apps that cater to diverse audiences. Whether you\'re targeting iOS, Android, or both, we\'re dedicated to delivering seamless user experiences, rapid development cycles, and cost-effective solutions.'
            ],
            img: {
                src: aboutReactNative,
                alt: "React Native Development"
            }
        }
    };
  return (
    <>
    <div className='relative overflow-hidden sm:top-[-20px] top-[-19px] z-10'>
    <Wave fill='#fff' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5}} className='relative min-w-[1920px] h-[28px] '/>
        <div className='bg-white'>
            <div className='container'>
                <div className={`flex items-center flex-wrap sm:pt-5 ${category === 'mobile' || category === 'design' || category === 'fullStack' || category === 'reactNative' ? 'flex-row-reverse' : ''}`}>
                    <div className='lg:w-3/5 w-full lg:ps-3 lg:pe-10 mt-11'>
                        {aboutService[category]?.paragraph?.map((ele, idx) => {
                            if (ele.includes('highlight-company')) {
                                return (
                                    <p className='xs:text-[16px] text-[14px] mb-5 mt-5 text-justify text-[#555555]' dangerouslySetInnerHTML={{ __html: ele }} key={idx}/>
                                );
                            }
                            return (
                                <p className='xs:text-[16px] text-[14px] mb-5 mt-5 text-justify text-[#555555]' key={idx}>{ele}</p>
                            )
                        })}
                    </div>
                    <div className='lg:w-2/5 w-full ps-3 pe-3 mt-11'>
                        <div className='flex justify-center '>
                            <img src={aboutService[category]?.img?.src} alt={aboutService[category]?.img?.alt} className='w-[470px] ' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default AboutService